

import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Button,
  useMediaQuery,
  Box,TextField
} from "@mui/material";
import { Menu as MenuIcon, ExitToApp as ExitToAppIcon } from "@mui/icons-material";
import { useNavigate, useLocation } from "react-router-dom";
import { FaRegUser } from "react-icons/fa";
import { useContext, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { BASE_URL } from "../../api/api";

const Header = ({ open, toggleSidebar }) => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const navigate = useNavigate();
  const { user, logout } = useContext(AuthContext);
  const [searchText, setSearchText] = useState("");

  const handleSearch = async () => {
    if (!searchText.trim()) return;

    try {
      const response = await fetch(`${BASE_URL}/GlobalSearchData`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ searchText }),
      });

      const data = await response.json();
      if (data && data.length > 0) {
        navigate("/global-search-result", { state: { searchResults: data } });
      } else {
        alert("No results found.");
      }
    } catch (error) {
      console.error("Search error:", error);
    }
  };
  const handleLogout = () => {
    logout();
    navigate("/");
  };

  const location = useLocation();
  const isFinance = user?.role === "finance" || user?.role === "Finance";
  const isVendorOnDashboard = location.pathname === "/Dashboard" && user?.role === "ServiceProvider";
  const hideSidebarControls = isFinance || isVendorOnDashboard;

  return (
    <AppBar
      position="fixed"
      elevation={0}
      className="header_and_sidebar_only_for_index"
      sx={{
        width: open && !isMobile && !hideSidebarControls ? `calc(100% - 250px)` : "100%",
        height: "64px",
        backgroundColor: "#fff",
        borderBottom: "1px solid #ddd",
      }}
    >
      <Toolbar>
        {!hideSidebarControls && (
          <IconButton
            edge="start"
            color="inherit"
            onClick={toggleSidebar}
            sx={{ color: "#000" }}
          >
            <MenuIcon />
          </IconButton>
        )}

        <Typography
          variant="h6"
          sx={{ flexGrow: 1, color: "#000" }}
        ></Typography>

        {!hideSidebarControls && (
          <TextField
            size="small"
            placeholder="Global Search..."
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyPress={(e) => e.key === "Enter" && handleSearch()}
            sx={{ width: 300 }}
          />
        )}
        {user && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Box
              className="rounded-circle bg-light d-flex justify-content-center align-items-center"
              sx={{ width: 40, height: 40 }}
            >
              <FaRegUser />
            </Box>
            <Typography variant="body2" sx={{ color: "#000" }}>
              {user.email}
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              onClick={handleLogout}
              sx={{
                bgcolor: "#8000d7",
                color: "white",
                "&:hover": {
                  bgcolor: "#8000d7",
                },
              }}
              startIcon={<ExitToAppIcon />}
            >
              Logout
            </Button>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;